import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MessagesModule } from 'primeng/messages';
import { SegmentFilterService } from '@modules/segments/services/filter-segment.service';
import { SegmentFilter } from '@modules/segments/models/segmentation.model';

@Component({
  selector: 'app-segment-filters-preview',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, MessagesModule],
  templateUrl: './segment-filters-preview.component.html',
})
export class SegmentFiltersPreviewComponent {
  @Input() name: string | null = null;
  @Input() filters: SegmentFilter[] = [];
  @Input() collectors: any[] = [];
  @Input() portfolios: any[] = [];
  @Input() showStatusBadges = false;
  @Input() isDefault = false;
  @Input() isInUse = false;

  constructor(private filterService: SegmentFilterService) {}

  getFilterText(filter: SegmentFilter): string {
    return this.filterService.getFilterText(filter, this.collectors, this.portfolios);
  }
}
